import CompanyDepartmentCard from "../../components/company-department/company-department-card/company-team-users";

const CompanyDepartment = () => {
  return (
    <>
      <CompanyDepartmentCard />
    </>
  );
};

export default CompanyDepartment;
